// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:960px){.tlm-checkout-overview__wrap[data-v-3bb8fd07]{position:sticky;top:0}}.tlm-checkout-overview__show-order[data-v-3bb8fd07]{background:var(--v-gray-lighten3);border-bottom:1px solid var(--v-gray-lighten1);border-top:1px solid var(--v-gray-lighten1);position:relative;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
